(function () {
	'use strict';

	window.js = window.js || {};
	js.searchResult = (function () {
		var
			_domElm,
			_resultList,
			_template,
			_defaultImage,
			_page = 1,
			_totalLoaded = 0,
			_searchInput;

		function load() {
			var keyword = _domElm.dataset.keyword || '';
			var area = _domElm.dataset.area || '';
			var url = '/api/searchapi/get?keyword={keyword}&page={page}&size=10&area={area}'.replace('{keyword}', keyword).replace('{page}', _page).replace('{area}',area);
			var searchPromise = fetch(url);
			searchPromise.then(function (result) {
				var resultStreamPromise = result.json();
				resultStreamPromise.then(function (searchResult) {
					_totalLoaded += searchResult.length;
					if (_domElm.dataset.resultCount <= _totalLoaded) {
						// hide the load more button
						_domElm.querySelector('.js-search-result__show-more').style.display = "none";
					}

					searchResult.forEach(function (item) {
						if (!item.PageImage) {
							item.PageImage = _defaultImage;
						}
						item.HasTags = item.Tags && item.Tags.length > 0;
						item.TagsText = _domElm.dataset.tagsText;
						var html = _template.render(item);
						_resultList.innerHTML += html;
						//console.log(html);
					});
				});
			})
		}

		function initialize(domElm) {
			var
				templatePromise;
			_domElm = domElm;

			_searchInput = _domElm.querySelector('.js-search-result__input');
			if (_searchInput) {
				_searchInput.addEventListener('blur', function () {
					if (this.value) {
						this.classList.add('focus');
					}
				});
			}

			_resultList = _domElm.querySelector('.js-search-result__list');

			templatePromise = fetch('/dist/searchresultpage/templates/search-result-item.mustache');
			templatePromise.then(function templateLoaded (results) {
				var templateStreamPromise = results.text();
				templateStreamPromise.then(function (text) {
					_template = Hogan.compile(text);
				});
			});

			_defaultImage = _domElm.dataset.defaultImage;

			if (_domElm.dataset.resultCount > 10) {
				_totalLoaded = 10;
			}
			var loadMoreBtn = _domElm.querySelector('.js-search-result__show-more');
			if (loadMoreBtn) {
				loadMoreBtn.addEventListener('click', function (e) {
					if (e) e.preventDefault

					_page += 1;
					load();
				});
			}
		}

		return {
			initialize: initialize
		};
	})();
})();